<div id="confirm-popup-overlay" class="confirm-overlay">
  <div id="confirm-popup-container" class="bg-white max-w-[620px] p-7 rounded-lg shadow-lg relative">
    <button id="confirm-popup-close-btn"
            class="absolute top-3 right-3 text-gray-400 hover:text-gray-700 focus:outline-none"
            (click)="onCancel()">
      <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </button>

    <h3 id="confirm-popup-title" class="text-xl font-bold mb-4">{{ headerText() }}</h3>
    <ng-content/>

    <div class="flex justify-end space-x-4 mt-6">
      <button id="confirm-popup-cancel-btn" class="cancel-btn" (click)="onCancel()">
        Cancel
      </button>

      <button id="confirm-popup-confirm-btn" class="confirm-btn" [style.background-color]="confirmColor()"
              (click)="onConfirm()">
        {{ confirmText() }}
      </button>
    </div>
  </div>
</div>
